import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";

export const DropPermissionUrl = `/do_drop_permission`;
export const DropPermissionMethod = ERequestType.TYPE_POST;

export interface DropPermissionBody extends ApiRequest {
	userId: string;
	permName: string;
	scope: string;
	allScope: boolean;
	project: string;
}

export interface DropPermissionResponse extends ApiResponse {
}
